<template>
  <AppHeader />
  <div class="min-h-screen bg-blue-50">
    <!-- Header section with UP colors -->
    <div class="bg-gradient-to-r from-blue-900 to-blue-700 py-8 shadow-md">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col items-center">
          <div class="text-center">
            <h1 class="text-2xl font-bold text-white mb-1">Page Not Found</h1>
            <p class="text-blue-100">The page you're looking for doesn't exist or has been moved</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Main content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="bg-white rounded-lg shadow-md p-8 max-w-md mx-auto flex flex-col items-center">
        <!-- Illustration -->
        <div class="bg-blue-100 rounded-full p-6 mb-6">
          <span class="material-symbols-outlined text-6xl text-blue-700">search_off</span>
        </div>
        
        <h2 class="text-5xl font-bold text-blue-900 mb-4">404</h2>
        <p class="text-xl text-gray-800 mb-2 font-medium">Oops! Page Not Found</p>
        <p class="text-gray-600 mb-8 text-center">
          Sorry, the page you're looking for doesn't exist or has been moved.
          If you think this is a mistake, please contact support.
        </p>
        
        <div class="flex flex-col sm:flex-row gap-4">
          <router-link 
            to="/" 
            class="inline-flex items-center justify-center px-6 py-3 bg-blue-900 text-white rounded-lg shadow hover:bg-blue-800 transition-colors duration-200 font-medium"
          >
            <span class="material-symbols-outlined mr-2">home</span>
            Return to Home
          </router-link>
          
          <button 
            @click="goBack" 
            class="inline-flex items-center justify-center px-6 py-3 bg-blue-100 text-blue-900 rounded-lg hover:bg-blue-200 transition-colors duration-200 font-medium"
          >
            <span class="material-symbols-outlined mr-2">arrow_back</span>
            Go Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue';
export default {
  name: 'NotFound',
  components: { AppHeader },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
}
</script>
